"use strict";
var appn;
(function (appn) {
    var toast;
    (function (toast) {
        function init() {
            const shouldCreateNotifications = function ($notification) {
                return $notification && $notification.text().trim().length > 0;
            };
            const $infoNotification = $('#info');
            if (shouldCreateNotifications($infoNotification))
                appn.toast.notify(Type.info, $infoNotification.html());
            const $errorNotifications = $('#error');
            if (shouldCreateNotifications($errorNotifications))
                appn.toast.notify(Type.error, $errorNotifications.html());
            const $successNotifications = $('#success');
            if (shouldCreateNotifications($successNotifications))
                appn.toast.notify(Type.success, $successNotifications.html());
        }
        toast.init = init;
        function notify(msgType, msgHtml, msgTitle) {
            const options = new Options();
            if (msgType !== Type.error) {
                const charCount = msgHtml.trim().length;
                options.timeOut = Math.max(Math.floor(charCount * 40), 3000).toString();
            }
            window.toastr.options = options;
            let title = appn.emptyString;
            if (msgTitle)
                title = msgTitle;
            else if (msgHtml && msgHtml.containsIgnoreCase('#TITLE#')) {
                const bits = msgHtml.split('#TITLE#');
                title = bits[0];
                msgHtml = bits[1];
            }
            else if (msgHtml.length <= 60) {
                title = msgHtml;
                msgHtml = appn.emptyString;
            }
            else if (msgHtml.contains('\n')) {
                const [first, ...rest] = msgHtml.split('\n');
                title = first;
                msgHtml = rest.join('<br>');
            }
            else if (msgHtml.containsIgnoreCase('<br>')) {
                const [first, ...rest] = msgHtml.split('<br>');
                title = first;
                msgHtml = rest.join('<br>');
            }
            if (title.containsIgnoreCase('success'))
                msgType = Type.success;
            const capitalizedTitle = title.charAt(0).toUpperCase() + title.slice(1);
            window.toastr[msgType](msgHtml, capitalizedTitle);
        }
        toast.notify = notify;
        const redirectNoticeKey = 'appn.toast.redirectNotice';
        function setRedirectNotice(msgType, msgHtml, msgTitle) {
            appn.localStorage.setItem(redirectNoticeKey, {
                msgType,
                msgHtml,
                msgTitle
            });
        }
        toast.setRedirectNotice = setRedirectNotice;
        function raiseRedirectNotice() {
            const notice = appn.localStorage.getItem(redirectNoticeKey);
            if (!appn.utils.hasValue(notice))
                return;
            appn.localStorage.removeItem(redirectNoticeKey);
            let { msgType, msgHtml, msgTitle } = notice;
            if (appn.utils.hasValue(msgTitle) || appn.utils.hasValue(msgHtml)) {
                if (!appn.utils.hasValue(msgType))
                    msgType = 'info';
                appn.toast.notify(msgType, msgHtml !== null && msgHtml !== void 0 ? msgHtml : appn.emptyString, msgTitle);
            }
        }
        toast.raiseRedirectNotice = raiseRedirectNotice;
        appn.pubSub.subscribe(appn.pubSub.APPN_READY, function (channel, data) {
            const errorList = $('div.alert ul.form-errors li');
            if (errorList.length === 0)
                return;
            errorList.each(function (index, element) {
                const id = $(element).attr('id');
                const child = $(`.card .card-body [id="${id}"]`);
                const card = child.closest('.card');
                const chevron = card.find('.card-btn-expand-or-collapse');
                const collapsed = chevron.find('i').hasClass('fa-chevron-down');
                if (collapsed)
                    chevron.click();
            });
        });
        class Options {
            constructor(options) {
                this.closeButton = false;
                this.debug = false;
                this.newestOnTop = true;
                this.progressBar = false;
                this.positionClass = PositionClass.br;
                this.preventDuplicates = true;
                this.onclick = null;
                this.showDuration = '300';
                this.hideDuration = '10';
                this.timeOut = '0';
                this.extendedTimeOut = '10000';
                this.showEasing = 'swing';
                this.hideEasing = 'linear';
                this.showMethod = 'fadeIn';
                this.hideMethod = 'fadeOut';
                if (options) {
                    this.closeButton = options.closeButton;
                    this.debug = options.debug;
                    this.newestOnTop = options.newestOnTop;
                    this.progressBar = options.progressBar;
                    this.positionClass = options.positionClass;
                    this.preventDuplicates = options.preventDuplicates;
                    this.onclick = options.onclick;
                    this.showDuration = options.showDuration;
                    this.hideDuration = options.hideDuration;
                    this.timeOut = options.timeOut;
                    this.extendedTimeOut = options.extendedTimeOut;
                    this.showEasing = options.showEasing;
                    this.hideEasing = options.hideEasing;
                    this.showMethod = options.showMethod;
                    this.hideMethod = options.hideMethod;
                }
            }
        }
        toast.Options = Options;
        let PositionClass;
        (function (PositionClass) {
            PositionClass["tr"] = "toast-top-right";
            PositionClass["br"] = "toast-bottom-right";
            PositionClass["bl"] = "toast-bottom-left";
            PositionClass["tl"] = "toast-top-left";
            PositionClass["tf"] = "toast-top-full-width";
            PositionClass["bf"] = "toast-bottom-full-width";
            PositionClass["tc"] = "toast-top-center";
            PositionClass["bc"] = "toast-bottom-center";
        })(PositionClass = toast.PositionClass || (toast.PositionClass = {}));
        let Type;
        (function (Type) {
            Type["success"] = "success";
            Type["info"] = "info";
            Type["warning"] = "warning";
            Type["error"] = "error";
        })(Type = toast.Type || (toast.Type = {}));
    })(toast = appn.toast || (appn.toast = {}));
})(appn || (appn = {}));
